<template>
    <b-card no-body class="nsp-card">
        <b-card-header class="d-flex align-items-center">
            <span class="nsp-title">{{ module.moduleName || $t('NSP_INDOOR') }}</span>
            <b-badge v-if="stale" class="ml-auto" variant="warning">{{ $t('NSP_WEATHER_STALE') }}</b-badge>
            <span v-else class="ml-auto small text-muted">{{ age }}</span>
        </b-card-header>

        <b-card-body>
            <div class="d-flex align-items-center mb-3">
                <div class="nsp-big">{{ show(temperature, 1) }}<small>&#8451;</small></div>
                <div class="ml-4">
                    <div class="small text-muted">{{ $t('NSP_DEW_POINT') }}</div>
                    <div>{{ show(num('DewPoint'), 1) }}&#8451;</div>
                </div>
                <div class="ml-4">
                    <div class="small text-muted">{{ $t('NSP_HUMIDITY') }}</div>
                    <div>{{ show(num('Humidity'), 0) }}%</div>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div>
                    <div class="small text-muted">{{ $t('NSP_CO2') }}</div>
                    <div class="nsp-weather-value">{{ show(num('CarbonDioxide'), 0) }} ppm</div>
                </div>
                <b-badge v-if="air" class="ml-auto" v-bind:variant="air.variant">{{ air.label }}</b-badge>
            </div>
        </b-card-body>

        <!-- whatever the screen wants under the readings, on the house screen
             this is the history panel -->
        <slot name="footer"></slot>
    </b-card>
</template>

<script>
import sensorCard from './sensorCard';

// Carbon dioxide in ppm. Outdoor air sits near 420, so the first band is air
// that has barely been breathed. Above 1200 is where people start reporting
// stuffiness and it is worth airing the house out.
const CO2_GOOD = 800;
const CO2_FAIR = 1200;

export default
{
    name: 'IndoorCard',
    mixins: [sensorCard],
    data()
    {
        return {
            // the sensor reports on tasmota's TelePeriod, five minutes by default
            staleMinutes: 15,
        };
    },
    computed:
    {
        /**
         * Prefer the logged value over modules.temperature. Both hold the same
         * reading, but the value row is the one written per valueType and so
         * cannot be confused with another measurement.
         */
        temperature()
        {
            const me = this;
            const logged = me.num('Temperature');

            return (logged === null) ? me.module.temperature : logged;
        },
        air()
        {
            const me = this;
            const co2 = me.num('CarbonDioxide');

            if (co2 === null)
            {
                return null;
            }

            if (co2 <= CO2_GOOD)
            {
                return { variant: 'success', label: me.$t('NSP_AIR_GOOD') };
            }

            if (co2 <= CO2_FAIR)
            {
                return { variant: 'warning', label: me.$t('NSP_AIR_FAIR') };
            }

            return { variant: 'danger', label: me.$t('NSP_AIR_POOR') };
        },
    },
};
</script>
